// src/js/components/Evaluation/Results.js
import React, { Component } from "react";
import { connect } from "react-redux";
import ModuleIntroduction from "./ModuleIntroduction";
import ModuleQuestion from "./ModuleQuestion";
// import ModuleComplete from "./ModuleComplete";
// import renderHTML from "react-render-html";

const mapStateToProps = state => {
    return {
        modules: state.data.questionnaire.modules,
        steps: state.steps
    };
};

function mapDispatchToProps(dispatch) {
    return {};
}

class ConnectedModule extends Component {
    render() {
        let displaymodule = this.props.modules[this.props.index];
        let output = displaymodule.steps[this.props.steps[this.props.index].step];
        let display = null;

        switch(output.action) {
            case 'module': {
                display = <ModuleIntroduction module={this.props.index} />;
                break;
            }
            case 'submodule': {
                display = <ModuleQuestion module={this.props.index} submodule={output.submodule} />;
                break;
            }
            // case 'complete': {
            //     display = <ModuleComplete module={this.props.index} />;
            //     break;
            // }
            default: {
                // hide - don't show anything;
            }
        }
        return (
            <div>{display}</div>
        )
    }
}
const Module = connect(mapStateToProps,mapDispatchToProps)(ConnectedModule);

export default Module;